import { AbstractModel } from './AbstractModel'

export class CustomerNote extends AbstractModel {
    customerId: number|null = null
    note: string|null = null
    createdAt: string|null = null
    updatedAt: string|null = null
}
